import axios from "axios";
import store from "@/store/store.js";
import moment from "moment";
import "moment/locale/id";
import router from "../router/index";

// const ip = "https://serova.id/api-eatlah/";
const ip = "https://serova.id/";
// const ip = "http://localhost:3000/";

const instance = axios.create({
  baseURL: ip,
});
// console.log('store', store.state)
instance.interceptors.request.use(async (req) => {
  let kode = store.state.kode_client ? store.state.kode_client : null;
  let exp = store.state.login_time ? store.state.login_time : moment();
  let now = moment();
  const isExpired = now.diff(exp, "seconds") > 0;
  // let path = router.app._route.meta.requiresAuth && router.app._route.path != '/login';
  // console.log(router.app._route.path, 'path');
  // if (path) {
  if (isExpired) {
    store.commit("logout");
    store.commit("set_alert", { variant: "danger", msg: "Sesi Login Anda Sudah Habis Silahkan Login Kembali", showing: true });
    setTimeout(() => {
      router.push("/login");
    }, 2000);
  } else {
    if (!ip.includes("localhost")) {
      // let kode = store.state.kode_client ? store.state.kode_client : null;
      req.baseURL = kode ? ip + "api-" + kode + "/" : ip;
    }
    let token = store.state.login_token;
    req.headers.token = token;
    if (req.method == "post") {
      if (!req.data) req.data = {};
      // console.log('req', req)
      req.data.companyId = kode;
      let mitra = store.state.mitra_aktif;
      req.data.mitraId = !req.data.mitraId && mitra ? mitra.id : req.data.mitraId;
      // req.data.mitraId = req.data.mitraId ? req.data.mitraId : mitra ? mitra.id : null

      let koordinator = store.state.koordinator_aktif;
      req.data.koordinatorId = !req.data.koordinatorId && koordinator ? koordinator.id : req.data.koordinatorId;

      let cabang = store.state.cabang_aktif;
      req.data.cabangId = !req.data.cabangId && cabang ? cabang.id : req.data.cabangId;

      let capem = store.state.capem_aktif;
      req.data.capemId = !req.data.capemId && capem ? capem.id : req.data.capemId;
    }
    return req;
  }
  // } else {
  //   // if (!ip.includes("localhost")) {
  //   //   req.baseURL = ip
  //   // }
  //   return req;
  // }
});

export default instance;
